import React, { ReactNode } from 'react';

import { StandardModal, ThemeButton } from '@ibinder/ui-common-core';

import { buttonTypes } from '@ibinder/ui-common-styles';

import { ModalPropsType } from '../../types/common.types';

import { FooterContainer, Container } from './Modal.styles';

interface FooterProps {
  onClose: () => void;
  cancelButtonText: string;
  actionButton: ReactNode;
}

const Footer: React.FC<FooterProps> = ({
  onClose,
  cancelButtonText,
  actionButton
}) => {
  return (
    <FooterContainer>
      <ThemeButton onClick={onClose} buttonType={buttonTypes.Default}>
        {cancelButtonText}
      </ThemeButton>
      {actionButton}
    </FooterContainer>
  );
};

export const Modal = ({
  handleClose,
  open,
  children,
  actionButton,
  cancelButtonText,
  footer,
  ...props
}: ModalPropsType) => {
  const onClose = () => {
    if (handleClose) handleClose();
    props.onClose();
  };
  return (
    <StandardModal
      {...props}
      headerText={props.headerText}
      onClose={onClose}
      open={!!open}
      footer={
        footer || (
          <Footer
            onClose={onClose}
            cancelButtonText={cancelButtonText || 'Cancel'}
            actionButton={actionButton}
          />
        )
      }
    >
      <Container>{children}</Container>
    </StandardModal>
  );
};
